const useArticleType = (
  type: string | undefined,
): { title: string | undefined; icon: string | undefined; slug: string | undefined } => {
  const mappings = {
    'eenvandaag-vraagt': {
      title: 'EenVandaag Vraagt',
      icon: 'eenvandaag-type:message',
      slug: '/eenvandaag-vraagt',
    },
    'opiniepanel/uitslagen': {
      title: 'Opiniepanel',
      icon: 'eenvandaag-type:chart-column-2',
      slug: '/opiniepanel',
    },
    'doe-mee': {
      title: 'Doe mee',
      icon: 'eenvandaag-type:message',
      slug: '/doe-mee',
    },
    uitlegvideos: {
      title: 'Uitlegvideo',
      icon: 'eenvandaag-type:play-outline',
      slug: '/uitlegvideos',
    },
    peilingtrends: {
      title: 'Peilingtrend',
      icon: 'eenvandaag-type:chart-line',
      slug: '/peilingtrends',
    },
  };

  return mappings[type as keyof typeof mappings] || null;
};

export default useArticleType;
